import script from "./InstructorDashboardView2.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructorDashboardView2.vue?vue&type=script&setup=true&lang=js"

import "./InstructorDashboardView2.vue?vue&type=style&index=0&id=5cae18b0&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cae18b0"]])

export default __exports__